var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 22.75,
    fill: "url(#paint0_linear_1_131)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3532 16.5893C37.5558 15.2804 36.3113 14.2473 35.1475 14.7582L11.9678 24.9354C11.1332 25.3018 11.1943 26.5659 12.0599 26.8416L16.8401 28.3638C17.7524 28.6544 18.7404 28.5042 19.537 27.9538L30.3143 20.5079C30.6393 20.2834 30.9936 20.7455 30.7159 21.0318L22.9582 29.0301C22.2056 29.8059 22.355 31.1206 23.2602 31.6883L31.9458 37.135C32.92 37.7459 34.1732 37.1322 34.3555 35.955L37.3532 16.5893Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_131",
    x1: 26,
    y1: 3.25,
    x2: 26,
    y2: 48.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7d2293a06237f1975c2ff8108045f0d9.svg";
export { ForwardRef as ReactComponent };